"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIndefiniteDate = exports.getMinimumLegalAgeDate = exports.isThisMonth = exports.isThisYear = exports.isYesterday = exports.isToday = exports.isTomorrow = exports.isAfter = exports.isBefore = exports.getDifferenceInYears = exports.getDifferenceInMonths = exports.getDifferenceInDays = exports.getSubYears = exports.getSubMonths = exports.getSubDays = exports.getAddYears = exports.getAddMonths = exports.getAddDays = exports.getEndOfYear = exports.getEndOfMonth = exports.getEndOfDay = exports.getStartOfYear = exports.getStartOfMonth = exports.getStartOfDayInTimezone = exports.getStartOfDay = exports.isDatesEqual = exports.getLastDateOfMonth = exports.getFirstDateOfMonth = exports.getPrevDay = exports.getNextDay = exports.getPrevMonth = exports.getNextMonth = exports.getDateByDayOfMonthNumber = exports.getDayOfMonthNumber = exports.getDayOfWeekNumber = exports.getAllWeekdayName = exports.getAllMonthName = exports.getMonthNameByMonthIndex = void 0;
const format_1 = require("./format");
// getMonthNameByMonthIndex
const getMonthNameByMonthIndex = (monthIndex, monthFormat = 'long') => {
    const date = new Date();
    date.setDate(1);
    date.setMonth(monthIndex - 1);
    return (0, format_1.formatDate)(date, { month: monthFormat });
};
exports.getMonthNameByMonthIndex = getMonthNameByMonthIndex;
// getAllMonthName
const getAllMonthName = (monthFormat = 'long') => Array.from({ length: 12 }, (_, i) => {
    return (0, format_1.formatDate)(new Date(0, i), { month: monthFormat });
});
exports.getAllMonthName = getAllMonthName;
// getAllWeekdayName
const getAllWeekdayName = (weekdayFormat = 'long', isSunday = false) => Array.from({ length: 7 }, (_, i) => {
    const initDate = new Date(isSunday ? '11/13/2022' : '11/14/2022'); // just a Monday
    initDate.setDate(initDate.getDate() + i);
    return (0, format_1.formatDate)(initDate, { weekday: weekdayFormat });
});
exports.getAllWeekdayName = getAllWeekdayName;
// getDayOfWeekNumber
const getDayOfWeekNumber = (date) => {
    return date.getDay();
};
exports.getDayOfWeekNumber = getDayOfWeekNumber;
// getDayOfMonthNumber
const getDayOfMonthNumber = (date) => {
    return date.getMonth() + 1;
};
exports.getDayOfMonthNumber = getDayOfMonthNumber;
// getDateByDayOfMonthNumber
const getDateByDayOfMonthNumber = (date, dayOfMontNumber) => {
    return new Date(new Date(date).setDate(dayOfMontNumber));
};
exports.getDateByDayOfMonthNumber = getDateByDayOfMonthNumber;
// getNextMonth
const getNextMonth = (date, monthFormat = 'long') => {
    date.setMonth(date.getMonth() + 1, 1);
    return (0, format_1.formatDate)(date, { month: monthFormat });
};
exports.getNextMonth = getNextMonth;
// getPrevMonth
const getPrevMonth = (date, monthFormat = 'long') => {
    date.setMonth(date.getMonth() - 1, 1);
    return (0, format_1.formatDate)(date, { month: monthFormat });
};
exports.getPrevMonth = getPrevMonth;
// getNextDay
const getNextDay = (currentDate) => {
    const nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + 1);
    return nextDay;
};
exports.getNextDay = getNextDay;
// getPrevDay
const getPrevDay = (currentDate) => {
    const prevDay = new Date(currentDate);
    prevDay.setDate(prevDay.getDate() - 1);
    return prevDay;
};
exports.getPrevDay = getPrevDay;
// getFirstDateOfMonth
const getFirstDateOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
};
exports.getFirstDateOfMonth = getFirstDateOfMonth;
// getLastDateOfMonth
const getLastDateOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};
exports.getLastDateOfMonth = getLastDateOfMonth;
// isDatesEqual
const isDatesEqual = (firstDate, secondDate, shouldCompareTime = false) => {
    const first = shouldCompareTime ? new Date(firstDate) : new Date(new Date(firstDate).setUTCHours(0, 0, 0, 0));
    const second = shouldCompareTime ? new Date(secondDate) : new Date(new Date(secondDate).setUTCHours(0, 0, 0, 0));
    return first.getTime() === second.getTime();
};
exports.isDatesEqual = isDatesEqual;
// startOfDay
const getStartOfDay = (date) => {
    date.setHours(0, 0, 0, 0);
    return date;
};
exports.getStartOfDay = getStartOfDay;
const getStartOfDayInTimezone = (date) => {
    date.setUTCHours(0, date.getTimezoneOffset(), 0, 0);
    return date;
};
exports.getStartOfDayInTimezone = getStartOfDayInTimezone;
// startOfMonth
const getStartOfMonth = (date) => {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
};
exports.getStartOfMonth = getStartOfMonth;
// startOfYear
const getStartOfYear = (date) => {
    date.setFullYear(date.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
};
exports.getStartOfYear = getStartOfYear;
// endOfDay
const getEndOfDay = (date) => {
    date.setHours(23, 59, 59, 999);
    return date;
};
exports.getEndOfDay = getEndOfDay;
// endOfMonth
const getEndOfMonth = (date) => {
    const month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
};
exports.getEndOfMonth = getEndOfMonth;
// endOfYear
const getEndOfYear = (date) => {
    const year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
};
exports.getEndOfYear = getEndOfYear;
// addDays
const getAddDays = (date, amount) => {
    if (!amount) {
        return date;
    }
    date.setDate(date.getDate() + amount);
    return date;
};
exports.getAddDays = getAddDays;
// addMonths
const getAddMonths = (date, amount) => {
    if (!amount) {
        return date;
    }
    const dayOfMonth = date.getDate();
    const endOfMonth = new Date(date.getTime());
    endOfMonth.setMonth(date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfMonth.getDate();
    if (dayOfMonth >= daysInMonth) {
        return endOfMonth;
    }
    date.setFullYear(endOfMonth.getFullYear(), endOfMonth.getMonth(), dayOfMonth);
    return date;
};
exports.getAddMonths = getAddMonths;
// addYears
const getAddYears = (date, years) => {
    date.setFullYear(date.getFullYear() + years);
    return date;
};
exports.getAddYears = getAddYears;
// subDays,
const getSubDays = (date, days) => {
    if (!days) {
        return date;
    }
    date.setDate(date.getDate() - (days >= 0 ? Math.floor(days) : days));
    return date;
};
exports.getSubDays = getSubDays;
// subMonths
const getSubMonths = (date, months) => {
    return (0, exports.getAddMonths)(date, -months);
};
exports.getSubMonths = getSubMonths;
// subYears
const getSubYears = (date, amount) => {
    return (0, exports.getAddYears)(date, -amount);
};
exports.getSubYears = getSubYears;
// differenceInDays
const getDifferenceInDays = (date1, date2) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};
exports.getDifferenceInDays = getDifferenceInDays;
// differenceInMonths
const getDifferenceInMonths = (endDate, startDate) => {
    return endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());
};
exports.getDifferenceInMonths = getDifferenceInMonths;
// differenceInYears
const getDifferenceInYears = (endDate, startDate) => {
    return Math.abs(startDate.getFullYear() - endDate.getFullYear());
};
exports.getDifferenceInYears = getDifferenceInYears;
// isBefore
const isBefore = (date1, date2) => {
    return date1.getTime() < date2.getTime();
};
exports.isBefore = isBefore;
// isAfter
const isAfter = (date1, date2) => {
    return date1.getTime() > date2.getTime();
};
exports.isAfter = isAfter;
// isTomorrow
const isTomorrow = (date1, date2) => {
    const tomorrow = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate() + 1);
    return tomorrow.getTime() === date2.getTime();
};
exports.isTomorrow = isTomorrow;
// isToday
const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};
exports.isToday = isToday;
// isYesterday
const isYesterday = (date1, date2) => {
    const yesterday = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate() - 1);
    return yesterday.getTime() === date2.getTime();
};
exports.isYesterday = isYesterday;
// isThisYear
const isThisYear = (date1, date2) => date1.getFullYear() === date2.getFullYear();
exports.isThisYear = isThisYear;
// isThisMonth
const isThisMonth = (date1, date2) => date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
exports.isThisMonth = isThisMonth;
const FEBRUARY = 1;
const MARCH = 2;
const FEBRUARY_LAST_DAY = 28;
const FEBRUARY_LAST_DAY_IN_LEAP_YEAR = 29;
const MONTH_FIRST_DAY = 1;
const minAge = 18;
const getMinimumLegalAgeDate = (date1, age = minAge) => {
    const dateOutput = new Date(date1);
    dateOutput.setFullYear(date1.getFullYear() - age);
    // Check if the original date is Feb 29 and the new date is Mar 1
    if (date1.getMonth() === FEBRUARY &&
        date1.getDate() === FEBRUARY_LAST_DAY_IN_LEAP_YEAR &&
        dateOutput.getMonth() === MARCH &&
        dateOutput.getDate() === MONTH_FIRST_DAY) {
        // Adjust the new date to Feb 28
        dateOutput.setDate(FEBRUARY_LAST_DAY);
        dateOutput.setMonth(FEBRUARY);
    }
    return dateOutput;
};
exports.getMinimumLegalAgeDate = getMinimumLegalAgeDate;
const INDEFINITE_DATE_YEAR = 9999;
const INDEFINITE_DATE_MONTH = 11;
const isIndefiniteDate = (date) => date.getFullYear() === INDEFINITE_DATE_YEAR && date.getMonth() === INDEFINITE_DATE_MONTH;
exports.isIndefiniteDate = isIndefiniteDate;
//# sourceMappingURL=dateHelpers.js.map